e<template>
  <v-container grid-list-xl toolOrderNumber="toolOrderNumber">
    <v-layout wrap>
      <v-flex xs12 v-if="!toolOrderNumber">
        <v-btn class="mr-4 mb-2" small text color="primary" to="/tools/orders">
          <v-icon small class="mr-1">chevron_left</v-icon>Orders
        </v-btn>
        <v-btn class="mr-4 mb-2" small color="primary" @click="reloadOrder">
          <v-icon small class="mr-2" left>shopping_cart</v-icon>Add these tools
          to cart
        </v-btn>
        <v-dialog
          v-model="issueDialog"
          width="800"
          v-if="toolOrder && toolOrder.status == 'open' && toolOrder.fulfilled"
        >
          <template v-slot:activator="{ on }">
            <v-btn class="mr-4 mb-2" small color="red" dark v-on="on">
              <v-icon small class="mr-2" left>report_problem</v-icon>Report
              Issue
            </v-btn>
          </template>

          <v-card class="pa-4">
            <v-card-title class="title pa-1" primary-title
              >Report Issue</v-card-title
            >

            <v-card-text class="pa-1">
              <p>
                If you had a problem with your order or tools were not delivered
                you can submit an issue on this order. <br />*The Yard Manager
                will be notified once you submit the issue.
              </p>
              <v-textarea
                outlined
                label="Add note here describing issue"
                class="mt-4"
                v-model="issueNote"
                autofocus
              ></v-textarea>
              <p class="subtitle-1">
                <v-icon left>report</v-icon>
                If tools were not delivered, please mark them below.
              </p>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" width="30"></th>
                      <th class="text-left" width="30"></th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="tool in issueToolList" :key="tool.id">
                      <td>
                        <v-checkbox
                          color="primary"
                          v-model="tool.issue"
                          :value="false"
                        ></v-checkbox>
                      </td>
                      <td class="pa-2">
                        <v-img
                          :src="tool.image"
                          width="30"
                          height="30"
                          contain
                        />
                      </td>
                      <td>{{ tool.title }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="issueDialog = false"
                >Cancel</v-btn
              >
              <v-btn color="primary" @click="submitIssue">Submit Issue</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>

      <v-flex xs12>
        <tool-order-details
          v-if="toolOrder"
          :toolOrder="toolOrder"
          :incomplete="incomplete"
        />
      </v-flex>

      <v-flex xs12>
        <v-card v-if="toolOrder">
          <v-card-title></v-card-title>
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left" width="100"></th>
                <th class="text-left">Name</th>
                <th class="text-center" width="50">Requested</th>
                <th class="text-center" width="50">Fulfilled</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tool in toolOrder.tools" :key="tool.id">
                <td class="pa-4">
                  <v-img :src="tool.image" width="50" height="50" contain />
                </td>
                <td>
                  {{ tool.title }}
                  <span
                    v-if="tool.deliveredBy"
                    class="caption secondary--text text--darken-4"
                    ><br />Delivery by: <strong>{{ tool.deliveredBy }}</strong>
                  </span>
                  <v-chip
                    class="ml-1"
                    x-small
                    v-if="tool.isRental"
                    color="green lighten-4"
                  >
                    <v-icon class="mr-1" x-small>monetization_on</v-icon>Rented
                    on
                    <span>{{
                      tool.rentalDate.toDate() | moment("MMM Do YYYY")
                    }}</span>
                  </v-chip>
                </td>
                <td class="text-center">{{ tool.qty }}</td>
                <td class="text-center">
                  {{ fulfilledAmount(tool) }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="toolOrder && toolOrder.issues">
        <h3 class="pa-3">
          Order Issues reported
        </h3>

        <v-simple-table class="elevation-2">
          <thead>
            <tr>
              <th class="text-left">Issue description</th>
              <th class="text-left">Tools</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(issue, ix) in toolOrder.issues" :key="ix">
              <td class="py-4">
                {{ issue.issueNote }}<br /><span class="caption grey--text">{{
                  issue.createDateString
                }}</span>
                <div v-if="issue.notes && issue.notes.length">
                  <p class="ma-0 mt-2">NOTES FROM YARD</p>
                  <div
                    v-for="(issueNote, noteIx) in issue.notes"
                    :key="noteIx"
                    class="primary--text"
                  >
                    <v-icon small left color="primary lighten-2">note</v-icon
                    >{{ issueNote.note }}
                    <span class="caption grey--text"
                      ><em>
                        by {{ issueNote.noteBy }} on
                        {{ issueNote.createDateString }}</em
                      ></span
                    >
                  </div>
                </div>
                <div v-if="issue.resolved">
                  <v-icon small left color="blue">check_circle</v-icon
                  ><strong>RESOLVED</strong>: {{ issue.resolved.note }}
                  <span class="caption grey--text"
                    ><em>
                      by {{ issue.resolved.resolvedBy }} on
                      {{ issue.resolved.createDateString }}</em
                    ></span
                  >
                </div>
              </td>
              <td>
                {{ issue.toolsWithIssues.map((t) => t.title).join(", ") }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snack" :timeout="5000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import fb from "@/main";
import { sortBy, sumBy } from "lodash";
import { mapState } from "vuex";
import moment from "moment";
import ToolOrderDetails from "@/components/toolOrders/ToolOrderDetails";
export default {
  props: ["toolOrderNumber"],
  components: { ToolOrderDetails },
  data() {
    return {
      search: "",
      issueDialog: false,
      issueNote: "",
      issueToolList: [],
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "imgUrl",
        },
        { text: "Title", value: "title" },
        { text: "Returned", value: "qtyReturned", align: "center" },
        { text: "QTY", value: "qty", align: "center" },
        { text: "", value: "status" },
      ],
      toolOrder: null,
      snack: false,
      snackColor: "",
      snackText: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  async created() {
    const orderNumber = this.$route.params.orderNumber || this.toolOrderNumber;
    try {
      const toolOrder = await fb.db
        .collection("toolOrders")
        .doc(orderNumber)
        .get();
      this.toolOrder = toolOrder.data();
      this.toolOrder.tools = sortBy(
        this.toolOrder.tools,
        [
          (t) => {
            return !t.consumable;
          },
        ],
        ["id"]
      ).reverse();
      this.toolOrder.tools.forEach((t) => {
        if (!t.fulfillments) t.fulfillments = [];
      });
      this.issueToolList = [...this.toolOrder.tools];
    } catch (error) {
      alert("Error getting orders.");
      console.log(error);
    }
  },
  methods: {
    reloadOrder() {
      this.$store.commit("reloadedOrder", this.toolOrder.tools);
      this.$router.push("/tools/cart");
    },
    async submitIssue() {
      if (!this.issueNote) {
        alert("Please make sure to add a note describing the issue.");
        return;
      }
      const issue = {
        issueNote: this.issueNote,
        toolsWithIssues: this.issueToolList.filter((t) => t.issue),
        createDateString: moment().format("MMM Do [at] h:mma"),
      };
      const issues = this.toolOrder.issues || [];
      issues.push(issue);
      await fb.db
        .collection("toolOrders")
        .doc(this.toolOrder.orderNumber)
        .update({
          issues,
        });
      this.issueDialog = false;
      this.snack = true;
      this.snackColor = "success";
      this.snackText =
        "Issue Successfully submitted and yard manager notified!";
      // add to local order
      this.toolOrder.issues = issues;
      // send to new collection in order to easily trigger email
      fb.db.collection("toolOrderIssues").add({
        toolOrderNumber: this.toolOrder.orderNumber,
        createdBy: this.user,
        jobSite: this.toolOrder.jobSite,
        createDate: fb.timestamp,
        ...issue,
      });
    },
    fulfilledAmount(tool) {
      if (!tool.fulfillments.length) {
        return tool.qtyFulfilled || 0;
      } else {
        return sumBy(tool.fulfillments, "qty");
      }
    },
    incomplete() {
      // cycle through all and determine if all items are fulfilled
      const found = this.toolOrder.tools.find((t) => {
        return this.fulfilledAmount(t) < t.qty;
      });
      return !!found;
    },
  },
};
</script>

<style scoped>
.order-details-label {
  width: 80px;
}
</style>
